import { Chip } from "@mui/material";
import { CorrectionManifestStatus } from "generated-graphql/graphql";

/**
 * EPA correction status → chip display. `Corrected` reads as complete (success),
 * `UnderCorrection` as in-progress / needs-attention (warning). Built to the
 * design-system chip spec (small, outlined, semantic colors). Renders nothing
 * for a manifest that has not entered correction.
 */
const CORRECTION_STATUS_CHIP: Record<
  CorrectionManifestStatus,
  { label: string; color: "success" | "warning" }
> = {
  [CorrectionManifestStatus.Corrected]: { label: "Corrected", color: "success" },
  [CorrectionManifestStatus.UnderCorrection]: { label: "Under correction", color: "warning" },
};

export function CorrectionStatusChip({
  status,
}: {
  status: CorrectionManifestStatus | null | undefined;
}) {
  const config = status ? CORRECTION_STATUS_CHIP[status] : null;
  if (!config) return null;
  return <Chip label={config.label} color={config.color} size="small" variant="outlined" />;
}
